class QueryStringReader {
    // Eg. rawQueryString = window.location.search
    constructor(rawQueryString) {
        this.rawQueryString = rawQueryString || '';
    }

    getValueByKey(key) {
        const results = new RegExp('[\?&]' + key + '=([^&#]*)')
                      .exec(this.rawQueryString);
        return results && results.length > 1 ? decodeURIComponent(results[1]) : null;
    }
}
